import {
	DatadogLogger,
	LoggerMessages,
	LoggerServices,
} from '~shared/services/logger';

export type GtmPayload = {
	event: string;
	data?: Record<string, unknown>;
} & Record<string, unknown>;

const maskEmailFieldsInPlace = ({ data }: GtmPayload) => {
	if (data?.email && typeof data.email === 'string') {
		data.email = '********@*****.***';
	}
};

export const maskEmailInPayload = (payload: GtmPayload): GtmPayload => {
	try {
		const clonedPayload = structuredClone(payload);
		maskEmailFieldsInPlace(clonedPayload);
		return clonedPayload;
	} catch (error) {
		DatadogLogger.error(
			LoggerServices.GTMAnalytics,
			LoggerMessages.Unknown,
			// @ts-ignore
			error.message
		);
		return payload;
	}
};

export const isHasOffers = (markers: Record<string, unknown>): boolean => {
	return (
		markers['transaction-id'] !== undefined ||
		markers['transaction_id'] !== undefined
	);
};
